import { FUNCTION_KEYS } from '@/constants';
import { type AccessScope } from '@/routers-capability/routeMeta';
import { FunctionKey } from '@/types';

const STORAGE_KEY = 'lastUsedAgent';

const isFunctionKey = (value: unknown): value is FunctionKey =>
  (FUNCTION_KEYS as readonly unknown[]).includes(value);

export const getLastUsedAgent = (): FunctionKey | null => {
  const value = localStorage.getItem(STORAGE_KEY);
  return isFunctionKey(value) ? value : null;
};

export const recordAgentVisit = (scope: AccessScope | undefined): void => {
  if (isFunctionKey(scope)) localStorage.setItem(STORAGE_KEY, scope);
};

export const clearLastUsedAgent = (): void => {
  localStorage.removeItem(STORAGE_KEY);
};
